module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('a', {
    attrs: {
      "href": "http://pushstart.com.br",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/logo_pushstart.png")
    }
  })]), _vm._v("\n    ©2019, PushStart.\n    Todos os direitos reservados.\n    \"O Show da Luna\" e seus personagens são propriedade da TV PinGuim.\n    @2018, TV PinGuim.\n  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ff863eb","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 60
// module chunks = 0